import {Fragment, useState} from 'react';
import dynamic from 'next/dynamic';
import {Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@material-ui/core';
import API from '../APIs/API';
import Utils from '../Core/Utils';

const Plot = dynamic(import('react-plotly.js'), {ssr: false});

class ActionLog {
    name: string = '';
    count: number = 0;
    exit: number = 0;
    time: number = 0;
}

export default function Analytics() {
    const [sessions, setSessions] = useState(null as [] | null);
    const [actions, setActions] = useState(new Array<ActionLog>());
    const [invalidSessions, setInvalidSessions] = useState(0);

    if (sessions == null) {
        Utils.Load('session-analytics', async (): Promise<any> => {
            const d = new Date(); // 2021, 3, 13
            const today = d.getUTCFullYear() + '-' + d.getUTCMonth() + '-' + d.getUTCDate();
            const ret = await API.Call('sessions/' + today, 'GET');
            return ret;
        }).then((ret) => {
            setInvalidSessions(ret.filter((x: any) => x.v.logs.length == 0).length);
            ret = ret.filter((x: any) => x.v.logs.length > 0);

            const actions = new Map<string, ActionLog>();
            ret.map((x: any) => {
                const logs = x.v.logs;
                const sessionActions = new Set<string>();
                logs.forEach((y: any, i: number) => {
                    var a = actions.get(y.action);
                    if (a == null) {
                        a = {name: y.action, count: 0, time: 0, exit: 0};
                        actions.set(y.action, a);
                    }
                    if (i < logs.length - 1) {
                        a.time += logs[i + 1].timestamp - logs[i].timestamp;
                    } else if (i == logs.length - 1) {
                        a.exit++;
                    }
                    sessionActions.add(y.action);
                });

                Array.from(sessionActions).forEach((ac) => {
                    let a = actions.get(ac);
                    if (a != null) {
                        a.count++;
                    }
                });
            });
            setSessions(ret);
            const al = Array.from(actions.values());
            al.sort((a, b) => {
                return b.count - a.count;
            });
            setActions(al);
        });
    }

    return (
        <Grid container spacing={3}>
            {sessions == null ? (
                <Grid item xs={12} style={{textAlign: 'center'}}>
                    loading, please wait...
                </Grid>
            ) : (
                <Fragment>
                    <Grid item xs={6}>
                        Logged {sessions.length} sessions today
                    </Grid>
                    <Grid item xs={6}>
                        {invalidSessions} sessions has no logs
                    </Grid>

                    <Grid item xs={12}>
                        <div style={{width: '100%'}}>
                            <Plot
                                style={{width: '100%', height: '300px'}}
                                data={[
                                    {
                                        name: 'Count',
                                        type: 'bar',
                                        x: actions.map((x) => x.name),
                                        y: actions.map((x) => x.count),
                                    },
                                    {
                                        name: 'Exit',
                                        type: 'bar',
                                        x: actions.map((x) => x.name),
                                        y: actions.map((x) => x.exit),
                                    },
                                ]}
                                layout={{
                                    title: 'View per Session',
                                    autosize: true,
                                    barmode: 'stack',
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table style={{minWidth: '100%'}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Action</TableCell>
                                        <TableCell>Average Time Spent</TableCell>
                                        <TableCell># of Views</TableCell>
                                        <TableCell># of Exits</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {actions.map((a) => (
                                        <TableRow key={a.name}>
                                            <TableCell>{a.name}</TableCell>
                                            <TableCell>{Math.round(a.time / a.count / 1000)} seconds</TableCell>
                                            <TableCell>{a.count}</TableCell>
                                            <TableCell>{a.exit}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Fragment>
            )}
        </Grid>
    );
}
